// extracted by mini-css-extract-plugin
export default {"headerRow":"mobile-hamburger-menu_headerRow__NxUJL","widgetsButton":"mobile-hamburger-menu_widgetsButton__dBumg","menuItems":"mobile-hamburger-menu_menuItems__9paUT"};